import { axiosRequestWithValidation } from "../service";
import {
  REACT_APP_VAM_CONTEXT_MASTER_ANIMAL_ATTACK,
  REACT_APP_VAM_CONTEXT_MASTER_LOSS_RESERVE,
  REACT_APP_VAM_ENDPOINT,
} from "../urls";

export const getAnimalAttackList = async () => {
  try {
    const response = await axiosRequestWithValidation().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_MASTER_ANIMAL_ATTACK}`
    );
    return response;
  } catch (error) {
    return null;
  }
};
export const editAnimalAttackMaster = async (data) => {
  try {
    const response = await axiosRequestWithValidation().put(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_MASTER_ANIMAL_ATTACK}`,
      data
    );
    return response;
  } catch (error) {
    return null;
  }
};
export const addNewAnimalAttackMaster = async (data) => {
  try {
    const response = await axiosRequestWithValidation().post(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_MASTER_ANIMAL_ATTACK}`,
      data
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const getAllLossReserve = async () => {
  try {
    const response = await axiosRequestWithValidation().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_MASTER_LOSS_RESERVE}`
    );
    return response;
  } catch (error) {
    return null;
  }
};

export const editLossReserve = async (data) => {
  try {
    const response = await axiosRequestWithValidation().put(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_MASTER_LOSS_RESERVE}`,
      data
    );
    return response;
  } catch (error) {
    return null;
  }
};
export const addNewLossReserve = async (data) => {
  try {
    const response = await axiosRequestWithValidation().post(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_MASTER_LOSS_RESERVE}`,
      data
    );
    return response;
  } catch (error) {
    return null;
  }
};
